import { render, staticRenderFns } from "./UEmojiPicker.vue?vue&type=template&id=123cdd3c&scoped=true&"
import script from "./UEmojiPicker.vue?vue&type=script&lang=js&"
export * from "./UEmojiPicker.vue?vue&type=script&lang=js&"
import style0 from "./UEmojiPicker.vue?vue&type=style&index=0&id=123cdd3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123cdd3c",
  null
  
)

export default component.exports